<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>c
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousBook" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Air Freight Execution (Export)</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button
              variant="success"
              size="sm"
              class="pull-right"
              v-if="totalCountSB==airExecutionShipperArray.length && airExecutionShipperArray.length>0"
              @click="proceedToTally"
            >Proceed To Invoice</b-button>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="airFreightModel.allModuleId ? airFreightModel.allModuleId : ''"
          :jobSeriesBanner="airFreightModel.airFFExportSeries ? airFreightModel.airFFExportSeries : ''"
          :bannerClientName="SBDetail.clientName ? SBDetail.clientName : '' "
          iconId="fa fa-ship" 
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2" v-if="packageDetails.length>0">
              <div>
                  <h5 >
                    <b-badge>Package Details</b-badge>
                  </h5>
              
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="portLocationNew" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.no</th>

                      <th>Client Name</th>

                      <th>No.of Package</th>

                      <th>Package Length</th>

                      <th>Package Width</th>

                      <th>Package Height</th>

                      <th>Unit</th>

                      <th>Package Volume</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item1,index) in packageDetails" :key="index">
                      <td>{{index+1}}</td>

                      <td>{{item1.clientName}}</td>

                      <td>{{item1.noOfPackage}}</td>

                      <td>{{item1.packageLength}}</td>

                      <td>{{item1.packageWidth}}</td>

                      <td>{{item1.packageHeight}}</td>

                      <td>{{item1.packageUnit}}</td>

                      <td>{{item1.packageVolume}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mt-3" v-if="airExecutionShipperArray.length>0">
           
                <h5 >
                    <b-badge>Shipper Details</b-badge>
                  </h5>
              
           

              <!-- /.box-header -->
              <div class="box-body">
                <table id="SBDetailr" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>SN.</th>
                      <th>Shipper Name</th>
                      <th>Airway Type</th>

                      <!-- <th>Item Number</th> -->
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in airExecutionShipperArray" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.clientName }}</td>
                      <td>{{item.typeAirway }}</td>

                      <td>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          @click="viewEditShipper(item)"
                        >Edit</b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
            <div
              v-if="shipperDetailArray.length>0 || airExecutionShipperDetail.airShipperExecutionId!=''"
            >
              <b-card style="background:whiteSmoke" class="gutr">
                <md-layout gutter>
               
                  <md-layout md-flex="45">
                    <label v-if="airExecutionShipperDetail.airShipperExecutionId==''">Shipper Name</label>
                    <model-list-select
                      v-if="airExecutionShipperDetail.airShipperExecutionId==''"
                      option-value="shipperFreightId"
                      option-text="clientNameNew"
                      :list="shipperDetailArray"
                      placeholder="Select Shipper Name"
                      v-model="airExecutionShipperDetail.shipperFreightId"
                      :isDisabled="airFreightModel.airFFType=='fclNormal'?true:false"
                    ></model-list-select>
                    <md-layout md-flex="100" v-else>
                      <label>Shipper Name</label>
                      <b-form-input :formatter="capitalizeAll" disabled v-model="airExecutionShipperDetail.consignorName"></b-form-input>
                    </md-layout>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.shipperFreightId && airFreightModel.airFFType!='fclNormal'"
                    >{{shipperIdError}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label>Cargo Receipt Date at {{airFreightModel.shipmentExecution=='AirFreight'?"Warehouse":" Warehouse"}}</label>
                    <date-picker
                    :format="selectDateFormat"
                      lang="en"
                      id="MAWBDate"
                      name="MAWBDate"
                      v-model="airExecutionShipperDetail.cargoReceipt"
                    ></date-picker>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.cargoReceipt"
                    >{{errorAirExecutionShipperDetail.cargoReceipt}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>{{airFreightModel.shipmentExecution=='AirFreight'?"Carting":" Carting"}} Date</label>
                    <date-picker
                    :format="selectDateFormat"
                      lang="en"
                      id="MAWBDate"
                      name="MAWBDate"
                      v-model="airExecutionShipperDetail.cargoDate"
                    ></date-picker>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.cargoDate"
                    >{{errorAirExecutionShipperDetail.cargoDate}}</span>
                  </md-layout>
                </md-layout>

                <md-layout gutter class="labelMargtop">
               
                  <md-layout md-flex="45">
                    <label>Type of Airway</label>
                    <model-list-select
                      option-value="value"
                      option-text="text"
                      :list="AirwayType"
                      placeholder="Select B/L"
                      v-model="airExecutionShipperDetail.typeAirway"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.typeAirway"
                    >{{errorAirExecutionShipperDetail.typeAirway}}</span>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="airExecutionShipperDetail.typeAirway=='HouseAirwayBL'"
                  ></md-layout>
                  <md-layout
                    md-flex="25"
                    v-if="airExecutionShipperDetail.typeAirway=='HouseAirwayBL'"
                  >
                    <label>Freight Terms For HAWB</label>
                    <model-list-select
                      option-value="value"
                      option-text="text"
                      :list="freightTerms"
                      placeholder="Select Terms"
                      v-model="airExecutionShipperDetail.HAWBTerms"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.HAWBTerms"
                    >{{errorAirExecutionShipperDetail.HAWBTerms}}</span>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="airExecutionShipperDetail.typeAirway=='HouseAirwayBL'"
                  ></md-layout>
                  <md-layout
                    md-flex="20"
                    v-if="airExecutionShipperDetail.typeAirway=='HouseAirwayBL'"
                  >
                    <label>Freight Terms For MAWB</label>
                    <model-list-select
                      option-value="value"
                      option-text="text"
                      :list="freightTerms"
                      placeholder="Select Terms"
                      v-model="airExecutionShipperDetail.MAWBTerms"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.MAWBTerms"
                    >{{errorAirExecutionShipperDetail.MAWBTerms}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout
                    md-flex="25"
                    v-if="airExecutionShipperDetail.typeAirway=='DirectAirwayBL'"
                  >
                    <label>Freight Terms</label>
                    <model-list-select
                      option-value="value"
                      option-text="text"
                      :list="freightTerms"
                      placeholder="Select Terms"
                      v-model="airExecutionShipperDetail.freightTerms"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.freightTerms"
                    >{{errorAirExecutionShipperDetail.freightTerms}}</span>
                  </md-layout>
                </md-layout>

                <md-layout gutter class="labelMargtop">
           
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>Consignor Name</label>
                      <b-form-input :formatter="capitalizeAll"
                        name="consignorName"
                        id="consignorName"
                        v-model="airExecutionShipperDetail.consignorName"
                      ></b-form-input>
                    </md-layout>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.consignorName"
                    >{{errorAirExecutionShipperDetail.consignorName}}</span>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <label>Consignee (Order)</label>
                      <b-form-input :formatter="capitalizeAll"
                        name="HAWBNumber"
                        id="HAWBNumber"
                        v-model="airExecutionShipperDetail.consigneeOrder"
                      ></b-form-input>
                    </md-layout>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.consigneeOrder"
                    >{{errorAirExecutionShipperDetail.consigneeOrder}}</span>
                  </md-layout>
                </md-layout>

                <!-- <md-layout gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Consignor Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  name="consignorAddress"
                  id="consignorAddress"
                  v-model="airExecutionShipperDetail.consignorAddress"
                ></b-form-textarea>
              </md-layout>
              <span
                class="error"
                v-if="!airExecutionShipperDetail.consignorAddress"
              >{{errorAirExecutionShipperDetail.consignorAddress}}</span>
            </md-layout>
                </md-layout>-->
                <md-layout md-gutter class="labelMargtop">
             
                  <md-layout md-flex="45">
                    <label>Delivery Agent</label>
                    <model-list-select
                      option-value="agntColoaderId"
                      option-text="agentName"
                      :list="agentMasterList"
                      placeholder="Select Agent"
                      v-model="airExecutionShipperDetail.delieveryAgent"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.delieveryAgent"
                    >{{errorAirExecutionShipperDetail.delieveryAgent}}</span>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <md-input-container>
                    <label for="billingParty">Billing Party</label>
                    <md-select
                      name="billingParty"
                      id="billingParty"
                      multiple
                      v-model="airExecutionShipperDetail.billingParty"
                    >
                      <md-option
                        v-for="(AdditionalMoreArray,index) in showAdditionalMoreTaskArray"
                        :key="index"
                        :value="AdditionalMoreArray"
                      >{{AdditionalMoreArray.show}}</md-option>
                    </md-select>
                  </md-input-container>
                  </md-layout>-->
                </md-layout>
                <md-layout gutter class="gutr">
                  <md-layout
                    md-flex="100"
                    v-for="(singleInput, index) in airExecutionShipperDetail.notifyList"
                    :key="index"
                  >
                    <md-layout md-flex="100">
                    
                      <md-layout md-flex="95" class>
                        <label>{{ notifyArray[index] }} Notify Party</label>
                      </md-layout>
                      <md-layout md-flex="5" class="gutr" v-if="index>1">
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="removeNotify(index)"
                          style="min-height:20px;height:20px"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="100">
                   
                      <md-layout md-flex="100">
                        <b-form-textarea :formatter="capitalizeAll"
                          id="inputValue"
                          name="inputValue"
                          v-model="singleInput.inputValue"
                        ></b-form-textarea>
                        <!-- <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor> -->
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout gutter class="gutr">
                 
                  <md-layout md-flex="20">
                    <b-button variant="outline-info" size="sm" @click="addNotify">Add More Notify</b-button>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="gutr">
                
                  <md-layout md-flex="10">
                    <b-button
                    class="smbutnWidth mt-3"
                      size="sm"
                      variant="info"
                      @click="addExecution('all')"
                      id="addButtonLoader1"
                    >{{airExecutionShipperDetail.airShipperExecutionId==''?'Save':'Save'}}</b-button>
                    <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                  </md-layout>
                </md-layout>
              </b-card>
            </div>
            <div class="mt-3" v-if="sbDetailArrayNew.length>0">
            
                 <h5 >
                    <b-badge> Shipping Bill Details</b-badge>
                  </h5>
                   <b-button
                 
                  v-if="totalCountSB==airExecutionShipperArray.length && SBDetail.airSBDetailId==''"
                  variant="outline-dark"
                  class="mt-2"
                  size="sm"
                  @click="showMoreSBDet"
                >Click here to {{showMoreSB==true?"Hide":"Add More"}} S/B Details</b-button>
             

              

              <!-- /.box-header -->
              <div class="mt-3">
                <table id="SBDetailr" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>SN.</th>
                      <th>Client Name</th>
                      <th>Shipping Bill No</th>
                      <th>Cargo Gross Weight</th>

                      <!-- <th>Item Number</th> -->
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in sbDetailArrayNew" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.clientName }}</td>
                      <td>{{item.shippingBillNo }}</td>
                      <td>{{item.cargoGrossWeight }}</td>

                      <td>
                        <b-button variant="outline-info" size="sm" @click="viewEditSB(item)">Edit</b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="removeCommon(item,index,'SB')"
                        >Delete</b-button>
                        <!-- /            @click="DeleteListSb(item.airSBDetailId)" -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <div v-if="shipperDetailArray.length==0">
              <div
                v-if="totalCountSB!=airExecutionShipperArray.length || showMoreSB==true || SBDetail.airSBDetailId!=''"
              >
                <b-card style="background:whiteSmoke" class="gutr">
                  <md-layout md-gutter>
             
                    <md-layout md-flex="95">
                      <label style="margin:0px">
                          <h5 >
                    <b-badge> Shipping Bill Details</b-badge>
                  </h5>
              
                       
                         
                          <span
                            class="error"
                            v-if="sbDetailArrayList.length==0"
                          >{{errorAtleastSb}}</span>
                        
                      </label>
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="labelMargtop">
                   
                    <md-layout md-flex="45">
                      <label v-if="SBDetail.airSBDetailId==''">Shipper Name</label>
                      <model-list-select
                        v-if="SBDetail.airSBDetailId==''"
                        option-value="airShipperExecutionId"
                        option-text="clientName"
                        :list="airExecutionShipperArray"
                        placeholder="Select Shipper Name"
                        v-model="SBDetail.airShipperExecutionId"
                      ></model-list-select>
                      <md-layout md-flex="100" v-else>
                        <label>Shipper Name</label>
                        <b-form-input :formatter="capitalizeAll" disabled v-model="SBDetail.clientName"></b-form-input>
                      </md-layout>
                      <span
                        class="error"
                        v-if="!SBDetail.airShipperExecutionId"
                      >{{errorSBExecution.airShipperExecutionId}}</span>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                 
                    <md-layout md-flex="15">
                      <label>Invoice Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        name="invoiceDate"
                        id="invoiceDate"
                        v-model="SBDetail.invoiceDate"
                        :minute-step="1"
                      ></date-picker>
                      <span
                        class="error"
                        v-if="!SBDetail.invoiceDate"
                      >{{errorSBExecution.invoiceDate}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Invoice No.</label>
                        <b-form-input :formatter="capitalizeAll" name="invoiceNo" id="invoiceNo" v-model="SBDetail.invoiceNo"></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!SBDetail.invoiceNo">{{errorSBExecution.invoiceNo}}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <label>Shipping Bill Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        name="shippingBillDate"
                        id="shippingBillDate"
                        v-model="SBDetail.shippingBillDate"
                        :minute-step="1"
                      ></date-picker>
                      <span class="error" v-if="shippingBillDate_err ? true : false">
                        {{ shippingBillDate_err }}
                      </span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Shipping Bill No.</label>
                        <b-form-input :formatter="capitalizeAll"
                          name="shippingBillNo"
                          id="shippingBillNo"
                          v-model="SBDetail.shippingBillNo"
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="shippingBillNo_err ? true : false">
                        {{ shippingBillNo_err }}
                      </span>
                    </md-layout>
                  </md-layout>

                  <!-- {{airFreightModel}} -->

                  <md-layout md-gutter class="labelMargtop">
                   
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Cargo Gross Weight</label>
                        <b-form-input :formatter="capitalizeAll"
                          name="cargoGrossWeight"
                          id="cargoGrossWeight"
                          v-model="SBDetail.cargoGrossWeight"
                        ></b-form-input>
                      </md-layout>
                      <span
                        class="error"
                        v-if="!SBDetail.cargoGrossWeight"
                      >{{errorSBExecution.cargoGrossWeight}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Cargo Net Weight</label>
                        <b-form-input :formatter="capitalizeAll"
                          name="cargoNetWeight"
                          id="cargoNetWeight"
                          v-model="SBDetail.cargoNetWeight"
                        ></b-form-input>
                      </md-layout>
                      <span
                        class="error"
                        v-if="!SBDetail.cargoNetWeight"
                      >{{errorSBExecution.cargoNetWeight}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <label>Clearance Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        name="clearanceDate"
                        id="clearanceDate"
                        v-model="SBDetail.clearanceDate"
                        :minute-step="1"
                      ></date-picker>
                      <span
                        class="error"
                        v-if="!SBDetail.clearanceDate"
                      >{{errorSBExecution.clearanceDate}}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10" style="margin-top:35px">
                      <b-button
                        variant="info"
                        size="sm"
                        id="addButtonLoaderSB"
                        @click="addSBDetail"
                      >{{SBDetail.airSBDetailId==''?"Add SB":"Update"}}</b-button>
                      <md-spinner md-indeterminate id="loaderSB" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>
            </div>

            <md-layout
              class="gutr"
              md-gutter
              v-if="totalCountSB==airExecutionShipperArray.length && airExecutionShipperArray.length>0"
            >
              <md-layout md-flex="25">
                <label>Handover Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  name="clearanceDate"
                  id="clearanceDate"
                  v-model="airExecutionModel.handoverDate"
                  :minute-step="1"
                ></date-picker>
                <span class="error" v-if="!airExecutionModel.handoverDate">{{handoverDateError}}</span>
              </md-layout>
            </md-layout>

            <!-- <md-layout md-gutter>
              <md-layout md-flex="75"></md-layout>
              <md-layout md-flex="25">
                <h4 class="showMoreData" @click="goToPackageDetails">Click here for Package Details</h4>
                <md-spinner md-indeterminate id="loaderpack" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>-->
            <div
             
             class="mt-3"
              v-if="totalCountSB==airExecutionShipperArray.length && airExecutionShipperArray.length>0"
            >
              <b-button variant="warning" size="sm" @click="uploadDocument()">Upload Document</b-button><br>
              <b-button
               
                class="mt-3"
                variant="primary"
                @click="addExecution('fdsfdsf')"
                id="addButtonLoader1"
              >Save & Proced to Cargo Tracking</b-button>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </div>
            <div
              v-if="airExecutionModel.airFFType=='fclConsolidation' && totalCountSB==airExecutionShipperArray.length && airExecutionShipperArray.length>0"
            >
              <b-button
                variant="primary"
                @click="consolMaster()"
                id="addButtonLoader1"
              >Consol Master Merge</b-button>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose7"
      ref="addPop7"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onCloseForward"
    ></md-dialog-confirm>

    <div>
      <b-modal
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        id="myDIV"
        hide-footer
        ref="DocPop"
      >
        <div class="d-block text-center">
          <b-card style="min-height:500px !important">
            <b-card-text>
              <b-button
                size="sm"
                class="pull-right"
                variant="outline-danger"
                @click="closeDialog"
              >Cancel & Close</b-button>

              <div>
                <md-layout md-gutter class="gutr mt-4">
                 
                  <md-layout md-flex="35">
                    <label>Document Type</label>
                    <model-list-select
                      option-value="uploadVal"
                      option-text="uploadText"
                      :list="uploadDocumentList"
                      placeholder="Select Document Type"
                      v-model="DocumentList.documentType"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!DocumentList.documentType"
                    >{{errorDocumentList.documentType}}</span>
                    <span
                      class="error"
                      v-if="!airExecutionShipperDetail.delieveryAgent"
                    >{{errorAirExecutionShipperDetail.delieveryAgent}}</span>
                  </md-layout>
                  <md-layout md-flex="5" v-if="DocumentList.documentType == 'Others'"></md-layout>
                  <md-layout md-flex="35" v-if="DocumentList.documentType == 'Others'">
                    <md-layout md-flex="100">
                      <label>Document Name</label>
                      <b-form-input :formatter="capitalizeAll"
                        name="cargoNetWeight"
                        id="cargoNetWeight"
                        v-model="DocumentList.docName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  </md-layout>
                   <md-layout md-gutter class="gutr mt-4">
            
                  <md-layout md-flex="30">
                    <md-input-container>
                      <label>Upload Document</label>
                      <md-file
                        name="uploadDocument"
                        id="uploadDocument"
                        v-model="DocumentList.uploadDocumentType"
                        multiple
                        @selected="onFileChangeCargo"
                      ></md-file>
                      <!-- <md-file name="" id="" v-model=""></md-file> -->
                    </md-input-container>
                    <span
                      class="error"
                      v-if="!DocumentList.uploadDocumentType"
                    >{{errorDocumentList.uploadDocumentType}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="10" style="margin-top:38px">
                    <b-button
                      variant="info"
                      size="sm"
                      @click="submitDoument()"
                      id="addButtonLoader3"
                    >Upload</b-button>
                    <md-spinner md-indeterminate id="loader3" style="display:none"></md-spinner>
                  </md-layout>
                </md-layout>

                <div class="box">
                  <!-- /.box-header -->
                  <div class="box-body" style="margin-top:5%">
                    <table id="truckDetail" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>SN.</th>
                          <th>Document Type</th>
                          <th>Uploaded Document</th>
                          <th>Delete </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="documentArrayList.length==0">
                          <td>-</td>
                          <td>No Document Type</td>
                          <td>No Document Uploaded</td>
                          <td>-</td>
                        </tr>
                        <tr v-else v-for="(item,index) in documentArrayList" :key="index">
                          <td>{{index+1}}</td>
                          <td>{{item.documentType}}</td>
                          <td>
                            <span
                              v-for="(itemDate,index) in item.uploadDocumentType"
                              :key="index"
                              class="showMoreData"
                              @click="showPrint(itemDate)"
                            >{{itemDate}} {{index != Object.keys(item.uploadDocumentType).length - 1?" , ":""}}</span>
                          </td>
                          <td>
                            <md-button
                              class="md-icon-button md-raised md-dense"
                               @click="removeCommon(item,index,'Doc')"
                             
                            >
                              <md-icon>delete_sweep</md-icon>
                               <!-- @click="DeleteDoc(item.execDocId,item.uploadDocumentType)" -->
                            </md-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.box-body -->
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Air Freight") &&
      this.$sessionsStorage.get("editffAirExport") != undefined &&
      this.$sessionsStorage.get("editffAirExport") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/airFreight/airFreightExecution"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      bookingShipmentName: [
        {
          bookingShipmentVal: "yes",
          bookingShipmentText: "Yes"
        },
        {
          bookingShipmentVal: "no",
          bookingShipmentText: "No"
        }
      ],
      value12: "",

      airExecutionModel: {
        airExecutionId: "",
        airFFType: "",

        handoverDate: "",
        airFcExportId: this.$sessionsStorage.get("editffAirExport")
      },

      DocumentList: {
        docName: "",
        execDocId: "",
        uploadDocumentType: "",
        documentType: ""
      },
      errorDocumentList: {
        uploadDocumentType: "",
        documentType: ""
      },
      arrayErrorerrorDocumentList: {
        uploadDocumentType: "Select upload Document",
        documentType: "Select Document Type"
      },

      airExecutionShipperDetail: {
        airExecutionId: "",
        airShipperExecutionId: "",
        cargoReceipt: "",
        clientName: "",
        shipperFreightId: "",
        cargoDate: "",
        typeAirway: "",
        HAWBTerms: "",
        MAWBTerms: "",
        freightTerms: "",
        consignorName: "",
        consignorAddress: "",
        consigneeOrder: "",
        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],
        delieveryAgent: "",
        billingParty: []
      },

      errorAirExecutionShipperDetail: {
        cargoReceipt: "",
        cargoDate: "",
        typeAirway: "",
        consignorName: "",
        // consignorAddress:"",
        consigneeOrder: "",
        delieveryAgent: ""
      },
      arrayErrorAirExecutionShipperDetail: {
        cargoReceipt: "Enter Cargo Reciept",
        cargoDate: "Enter Cargo Date",
        typeAirway: "Enter Type of Airway",
        consignorName: "Enter Consignor Name",
        // consignorAddress: "Enter Consignor Address",
        consigneeOrder: "Enter Consignee Order",
        delieveryAgent: "Select Delievery Agent"
      },
      handoverDateError: "",

      shippingBillDate_err: "",
      shippingBillNo_err: "",

      SBDetail: {
        airShipperExecutionId: "",
        airSBDetailId: "",
        clientName: "",
        invoiceNo: "",
        invoiceDate: "",
        shippingBillDate: "",
        shippingBillNo: "",
        clearanceDate: "",
        cargoGrossWeight: "",
        cargoNetWeight: ""
      },
      errorSBExecution: {
        airShipperExecutionId: "",
        invoiceNo: "",
        invoiceDate: "",
        // shippingBillDate: "",
        // shippingBillNo: "",
        clearanceDate: "",
        cargoGrossWeight: "",
        cargoNetWeight: ""
      },

      arraySBExecutionError: {
        airShipperExecutionId: "Select Shipper Name",
        invoiceNo: "Enter invoice No",
        invoiceDate: "Enter invoice Date",
        // shippingBillDate: "Enter Shipping Bill Date",
        // shippingBillNo: "Enter Shipping Bill No",
        clearanceDate: "Enter Clearance Date",
        cargoGrossWeight: "Enter Cargo Gross Weight",
        cargoNetWeight: "Enter Cargo net Weight"
      },

      shipperIdError: "",
      shipperDetailArray: [],
      packageDetails: [],

      sbDetailArrayNew: [],

      airFreightModel: {},

      portMasterList: [],
      airExecutionShipperArray: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },

      uploadDocumentList: [
        {
          uploadText: "Final Invoice",
          uploadVal: "Final Invoice"
        },
        {
          uploadText: "Packing List",
          uploadVal: "Packing List"
        },
        {
          uploadText: "Shipping Bill",
          uploadVal: "Shipping Bill"
        },
        {
          uploadText: "Master B /L",
          uploadVal: "Master B/L"
        },
        {
          uploadText: "House B/L",
          uploadVal: "House B/L"
        },
        {
          uploadText: "Cargo Manifest",
          uploadVal: "Cargo Manifest"
        },
        {
          uploadText: "Marking/Labelling",
          uploadVal: "Marking_Labelling"
        },
        {
          uploadText: "Palletization",
          uploadVal: "Palletization"
        },
        {
          uploadText: "Fumigation",
          uploadVal: "Fumigation"
        },
        {
          uploadText: "Legalization",
          uploadVal: "Legalization"
        },
        {
          uploadText: "COC/GSP",
          uploadVal: "COC_GSP"
        },
        {
          uploadText: "Phyto",
          uploadVal: "Phyto"
        },
        {
          uploadText: "APEDA",
          uploadVal: "APEDA"
        },
        {
          uploadText: "Health Certificate",
          uploadVal: "Health_Certificate"
        },
        {
          uploadText: "Wildlife NOC",
          uploadVal: "Wildlife_NOC"
        },
        {
          uploadText: "Others",
          uploadVal: "Others"
        }
      ],

      showMoreSB: false,
      getContainerList: [],
      getSBDetailArray: [],

      freightTerms: [
        {
          value: "Prepaid",
          text: "Prepaid"
        },
        {
          value: "Collect",
          text: "Collect"
        }
      ],
      AirwayType: [
        {
          value: "HouseAirwayBL",
          text: "House Airway B/L"
        },
        {
          value: "DirectAirwayBL",
          text: "Direct Airway B/L"
        }
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",
      sbDetailArray: [],

      tentativeDetailArray: [],
      agentMasterList: [],
      deleteId: "",
      validateTrans: true,
      arrayError: [
        "Enter your tentative port Name",
        "Select ETA Date",

        "Select ETA Date"
      ],
      showAddAirport: false,
      errorBooking: {
        bookingNumber: "",
        validityBookingDate: "",
        SICutOff: "",
        bookingShipment: ""
      },
      bookingLengthError: "",
      arrayBookingError: [
        "Enter Booking Number",
        "Enter Validity Booking Number",
        "Enter SI Cut off",
        "Select Booking Shipment"
      ],
      documentArrayList: [],

      showAdditionalMoreTaskArray: [
        {
          value: "CONSIGNOR_Name",
          show: "CONSIGNOR_Name"
        },
        {
          value: "CONSIGNEE_Name",
          show: "CONSIGNEE_Name"
        },
        {
          value: "NOTIFY PARTY_Name",
          show: "NOTIFY PARTY_Name"
        },

        {
          value: "SECOND NOTIFY PARTY­ Name",
          show: "SECOND NOTIFY PARTY­ Name"
        },
        {
          value: "DELIVERY AGENT­ Name",
          show: "DELIVERY AGENT­ Name"
        },

        {
          value: "Other Specify",
          show: "Other Specify"
        }
      ],
      notifyList: [
        {
          inputValue: "",
          text: ""
        },
        {
          inputValue: "",
          text: "Second"
        }
      ],
      editIndex: "",
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],
      validateSB: true,
      totalCountSB: 0,
      uploadDelete: []
    };
  },

  mounted() {},
  watch: {
    airExecutionShipperDetail: {
      handler: function(newVal, oldVal) {
        if (this.airExecutionShipperDetail.shipperFreightId != "") {
          let arrayNew = this.shipperDetailArray.filter(x => {
            return (
              x.shipperFreightId ==
              this.airExecutionShipperDetail.shipperFreightId
            );
          });

          if (arrayNew.length > 0) {
            this.airExecutionShipperDetail.shipperFreightId =
              arrayNew[0].shipperFreightId;
            this.airExecutionShipperDetail.consignorName =
              arrayNew[0].clientNameNew;
            this.airExecutionShipperDetail.clientName =
              arrayNew[0].clientNameNew;
            // this.airExecutionShipperDetail.consignorAddress =
            //   arrayNew[0].corporateAddress;
            this.airExecutionShipperDetail.cargoReceivedAt =
              arrayNew[0].cargoReceivedAt;
            // this.airExecutionShipperDetail.typeAirway = arrayNew[0].typeAirway;
            this.airExecutionShipperDetail.HAWBTerms = arrayNew[0].HAWBTerms;
            this.airExecutionShipperDetail.MAWBTerms = arrayNew[0].MAWBTerms;
            this.airExecutionShipperDetail.freightTerms =
              arrayNew[0].freightTerms;
          }
        }
      },
      deep: true
    },
    SBDetail: {
      handler: function(newVal, oldVal) {
        if (this.SBDetail.airShipperExecutionId != "") {
          let arrayNew = this.airExecutionShipperArray.filter(x => {
            return (
              x.airShipperExecutionId == this.SBDetail.airShipperExecutionId
            );
          });

          if (arrayNew.length > 0) {
            this.SBDetail.clientName = arrayNew[0].clientName;
          }
        }
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    BannerComponent,
    CustomLoader,
  },
  computed: {
    sbDetailArrayList() {
      return this.sbDetailArray;
    },

    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },
  methods: {
     removeCommon(item, index,code) {
      // console.log("Priyanshu SIngh=>",item);return false;
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocActive = (code=='SB'?(item.isActiveSBExec == "1" ? 0 : 1):(item.isActiveDoc == "1" ? 0 : 1));
      let paylod = {
        tableName: code=='SB'?"air_exec_sb_detail":"air_exec_document",
        tableId: code=='SB'?"airSBDetailId":"execDocId",
        tableIsActive: code=='SB'?"isActiveSBExec":"isActiveDoc",
        value1: this.itemObj.isDocActive,
        tableVal: code=='SB'?item.airSBDetailId:item.execDocId,
        isMailSend:'No',
        manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    proceedToTally() {
      console.log("airFreightModel=>",this.airFreightModel)
      this.$router.push({
        path: "/airFreight/airFreightInvoice?JobType=FF&ShipmentType=Air&ModuleType="+this.airFreightModel.transportType
      });
    },
    onCloseForward() {
      this.$router.push({
        path: "/airfreight/airTrackingFFExport"
      });
    },
    doLoading() {
      this.isLoading = true;
    },
    showAddAirportmet() {
      if (this.showAddAirport == false) {
        this.showAddAirport = true;
      } else {
        this.showAddAirport = false;
      }
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    consolMaster() {
      this.$router.push({
        path: "/airFreight/cansolMasterMerge"
      });
    },
    autoENSDate() {
      this.BookingShippingLine.SICutOff = this.BookingShippingLine.ENSCutDate;
    },
    goToPackageDetails() {
      this.$router.push({
        path: "/airfreight/updatePackageExection"
      });
    },

    onClose() {},

    viewEditShipper(item) {
      Object.keys(this.airExecutionShipperDetail).map(x => {
        if (x == "notifyList") {
          this.airExecutionShipperDetail.notifyList = [];

          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyArray[index]
            };

            this.airExecutionShipperDetail.notifyList.push(obj);
          });
        } else if (x == "billingParty") {
          let array = item[x].split(",");

          this.showAdditionalMoreTaskArray.map((x, index) => {
            let i = array.indexOf(x.value);

            i >= 0 ? this.airExecutionShipperDetail.billingParty.push(x) : "";
          });
        } else {
          this.airExecutionShipperDetail[x] = item[x];
        }
      });
    },

    viewEditSB(item) {
      Object.keys(this.SBDetail).map(x => {
        this.SBDetail[x] = item[x];
      });
    },

    validateExecution() {
      let validate_new = true;

      Object.keys(this.errorAirExecutionShipperDetail).map((x, index) => {
        if (this.airExecutionShipperDetail[x] == "") {
          this.errorAirExecutionShipperDetail[
            x
          ] = this.arrayErrorAirExecutionShipperDetail[x];
          validate_new = false;
        }
      });

      if (
        this.airExecutionShipperDetail.shipperFreightId == "" &&
        this.airFreightModel.airFFType != "fclNormal"
      ) {
        this.shipperIdError = "Select Shipper Id";
        validate_new = false;
      } else {
        this.shipperIdError = "";
      }

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },

    DeleteListSb(item) {
      this.deleteId = item;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[x];
          validate_new = false;
        }
      });
      
      if (this.SBDetail.shippingBillDate == "" && this.airFreightModel.shipmentExecution == "AirFreight") {
        this.shippingBillDate_err = "Enter Shipping Bill Date";
        validate_new = false;
      } else {
        this.shippingBillDate_err = "";
      }

      if (this.SBDetail.shippingBillNo == "" && this.airFreightModel.shipmentExecution == "AirFreight") {
        this.shippingBillNo_err = "Enter Shipping Bill No";
        validate_new = false;
      } else {
        this.shippingBillNo_err = "";
      }
      
      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    DeleteDoc(item, upload) {
      this.deleteId = item;
      this.uploadDelete = upload;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop7"].open();
    },
    addSBDetail() {
      this.SBDetail["airFcExportId"] = this.$sessionsStorage.get(
        "editffAirExport"
      );
      this.SBDetail["airExecutionId"] = this.airExecutionModel.airExecutionId;

      this.validateSBDetail();
      if (this.validateSB == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addSBExecDetail.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              Object.keys(this.SBDetail).map(x => {
                this.SBDetail[x] = "";
              });

              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addExecution(id) {
      let arrayBilling = [];
      let arraynotifyList = [];

      if (this.airExecutionShipperDetail.billingParty.length > 0) {
        this.airExecutionShipperDetail.billingParty.map(x => {
          arrayBilling.push(x.value);
        });
      }
      if (this.airExecutionShipperDetail.notifyList.length > 0) {
        this.airExecutionShipperDetail.notifyList.map(x => {
          arraynotifyList.push(x.inputValue);
        });
      }
      this.airExecutionShipperDetail["billingPartyNew"] = arrayBilling;
      this.airExecutionShipperDetail["notifyListNew"] = arraynotifyList;

      let newData = {
        airExecutionShipperDetail: this.airExecutionShipperDetail,
        airExecutionModel: this.airExecutionModel
      };

      if (id == "all") {
        this.validateExecution();

        newData["onlyExecMain"] = "";
      } else {
        newData["onlyExecMain"] = "fdsfd";
      }

      if (this.validateSB == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addExecutionDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.airExecutionModel.airExecutionId = data.airExecutionId;

              this.$sessionsStorage.set(
                "editAirExecutionId",
                data.airExecutionId
              );

              Object.keys(this.airExecutionShipperDetail).map(x => {
                if (x == "billingParty") {
                  this.airExecutionShipperDetail[x] = [];
                } else if (x == "notifyList") {
                  this.airExecutionShipperDetail[x] = [
                    {
                      inputValue: "",
                      text: ""
                    },
                    {
                      inputValue: "",
                      text: "Second"
                    }
                  ];
                } else {
                  this.airExecutionShipperDetail[x] = "";
                }
              });
              Object.keys(this.errorAirExecutionShipperDetail).map(x => {
                this.errorAirExecutionShipperDetail[x] = "";
              });

              if (id != "all") {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop2"].open();
              }

              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    onClose7(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "air_exec_document",
          tableId: "execDocId",
          isActive: "isActiveDoc",
          tableVal: this.deleteId,
          uploadDelete: this.uploadDelete,
          link: `/AirExecDoc`
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/deletePermanentWithFile.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "air_exec_sb_detail",
          tableId: "airSBDetailId",

          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },
    viewEdit(item, index) {
      this.showAddAirport = true;

      Object.keys(item).map(x => {
        this.moreAirportModel[x] = item[x];
      });
    },

    previousBook() {
      this.$router.push({
        path: "/airfreight/airFreightBooking"
      });
    },
    validateTranshipment() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.TranshipmentDetail[x] == "") {
          this.errorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addBookingDetail() {
      this.BookingShippingLine[
        "transhipmentDetail"
      ] = this.tentativeDetailArray;

      this.validateBooking();

      if (this.validateTrans != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: "fdsfdsf"
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addBookingDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.BookingShippingLine.airBookingId = data.airBookingId;
              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (this.BookingShippingLine.airBookingId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$refs["addPopForward"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.airExecutionShipperDetail.notifyList.length]
      };
      this.airExecutionShipperDetail.notifyList.push(obj);
    },
    removeNotify(index) {
      this.airExecutionShipperDetail.notifyList.splice(index, 1);
    },

    validateBooking() {
      let validate_new = true;
      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.errorArrayBookingShippingLine[
            x
          ];
          validate_new = false;
        }
      });

      if (
        this.BookingShippingLine.bookingShipment == "yes" &&
        this.tentativeDetailArray.length == 0
      ) {
        this.bookingLengthError = "Select Atleast one transhipment";
        validate_new = false;
      } else {
        this.bookingLengthError = "";
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    validateAddAirport() {
      let validate_new = true;

      Object.keys(this.errorMoreAirport).map((x, index) => {
        if (this.moreAirportModel[x] == "") {
          this.errorMoreAirport[x] = this.arratErrorAirport[x];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addAirport() {
      this.validateAddAirport();
      if (this.validateTrans != false) {
        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: ""
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addBookingDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.BookingShippingLine.airBookingId = data.airBookingId;
              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);

              Object.keys(this.moreAirportModel).map(x => {
                this.moreAirportModel[x] = "";
              });
              Object.keys(this.errorMoreAirport).map(x => {
                this.errorMoreAirport[x] = "";
              });
              this.showAddAirport = false;
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    getData() {
      this.doLoading();


      let new_data = {
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),

        airBookingId:
          this.$sessionsStorage.get("editAirBookingId") != "" &&
          this.$sessionsStorage.get("editAirBookingId") != undefined
            ? this.$sessionsStorage.get("editAirBookingId")
            : "",
        airExecutionId:
          this.$sessionsStorage.get("editAirExecutionId") != "" &&
          this.$sessionsStorage.get("editAirExecutionId") != undefined
            ? this.$sessionsStorage.get("editAirExecutionId")
            : "",
        itemCode: "dsfds"
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/viewAirfreightExecution.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          
          if ( status == 200 && data) {
            
            // this.portMasterList = data.portLocationArray.filter(x => {
            //   return x.locationType == "Air_Port";
            // });
            
            if (data.airFreightDetail.length > 0) {
              Object.keys(data.airFreightDetail[0]).map(x => {
                this.airFreightModel[x] = data.airFreightDetail[0][x] || "";
              });
            }
            if (data.shipperDetail.length > 0) {
              this.shipperDetailArray = data.shipperDetail;
            } else {
              this.shipperDetailArray = [];
            }
            if (data.packageDetailCargo.length > 0) {
              this.packageDetails = data.packageDetailCargo;
            } else {
              this.packageDetails = [];
            }

            if (data.airFreightExecution.length > 0) {
              Object.keys(this.airExecutionModel).map(x => {
                this.airExecutionModel[x] =
                  data.airFreightExecution[0][x] || "";
              });
            } else {
              this.airExecutionModel.airFFType =
                data.airFreightDetail[0].airFFType;

              if (data.airFreightDetail[0].airFFType == "fclNormal") {
                this.airExecutionShipperDetail.shipperFreightId =
                  data.shipperDetail[0].shipperFreightId;
              }
            }

            if (data.airFreightSBDetailArray.length > 0) {
              this.sbDetailArrayNew = data.airFreightSBDetailArray;
            } else {
              this.sbDetailArrayNew = [];
            }

            if (data.airFreightExecutionShipper.length > 0) {
              this.airExecutionShipperArray = data.airFreightExecutionShipper;
            } else {
              this.airExecutionShipperArray = [];
            }

            this.agentMasterList = data.agentMasterList;

            if (data.airExecDocumentArray.length > 0) {
              this.documentArrayList = data.airExecDocumentArray;

              this.documentArrayList.map((x, index) => {
                this.documentArrayList[
                  index
                ].uploadDocumentType = x.uploadDocumentType.split(",");
              });
            } else {
              this.documentArrayList = [];
            }

            this.doLoadingClose();
            this.totalCountSB = data.totalSBDetail;
            
          }
        })
        .catch(error => {});
    },
    uploadDocument() {
      this.$refs["DocPop"].show();
    },
    closeDialog() {
      this.$refs["DocPop"].hide();
    },

    validateDocument() {
      let validate_new = true;

      Object.keys(this.errorDocumentList).map((x, index) => {
        if (this.DocumentList[x] == "") {
          this.errorDocumentList[x] = this.arrayErrorerrorDocumentList[x];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },

    submitDoument() {
      if (this.DocumentList.documentType == "Others") {
        this.DocumentList.documentType = this.DocumentList.docName;
      }
      this.DocumentList["airFcExportId"] = this.$sessionsStorage.get(
        "editffAirExport"
      );
      this.DocumentList[
        "airExecutionId"
      ] = this.airExecutionModel.airExecutionId;
      this.validateDocument();
      if (this.validateSB == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addExecDocumentUpload.php`,
          data: JSON.stringify(this.DocumentList),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              Object.keys(this.DocumentList).map(x => {
                this.DocumentList[x] = "";
              });
              Object.keys(this.errorDocumentList).map(x => {
                this.DocumentList[x] = "";
              });

              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    onFileChangeCargo() {
      $("#addButtonLoader3").css("display", "none");
      $("#loader3").css("display", "block");

      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editffAirExport") +
            "-" +
            this.documentArrayList.length
        );

        formData.append("staticFileName", "Air_Export__ExecDoc");

        formData.append("upload_dir_folderName", "FF_Air_Export_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then(result => {
          this.DocumentList.uploadDocumentType = result.data;
          $("#loader3").css("display", "none");
          $("#addButtonLoader3").css("display", "block");
        })
        .catch(err => {
          throw err;
        });
    },

    showPrint(itemDate) {
      window.open(
        `${this.docURL}/FF_Air_Export_Uploads/` + itemDate
      );
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.widthCLass .md-dialog {
  width: 45%;
  height: auto;
  overflow: visible !important;
}
</style>        


// WEBPACK FOOTER //
// AirFreightExecution.vue?1d839fd4